// dito ASK — Icon-Register für Etappen (Sprint 4h). Gemeinsam für Verwaltung (Editor, Auswertung) und Teilnahme.
// Linien-Icons im 24er-Raster (Strich in currentColor), Schlüssel wie SurveyEditorService::STAGE_ICONS.
// Kein innerHTML: die Pfade werden als SVG-Elemente erzeugt (CSP, keine Nutzerdaten).

const NS = 'http://www.w3.org/2000/svg';

export const STAGE_ICONS = {
  flag:      { label: 'Fahne',        d: 'M6 21V4M6 4h11l-3 4 3 4H6' },
  school:    { label: 'Schule',       d: 'M3 21V10l9-6 9 6v11M9 21v-6h6v6M3 21h18' },
  classroom: { label: 'Klassenzimmer', d: 'M4 5h16v10H4zM8 19h8M12 15v4' },
  book:      { label: 'Buch',         d: 'M4 5a3 3 0 0 1 3-3h13v16H7a3 3 0 0 0-3 3zM4 5v16M7 18h13' },
  pencil:    { label: 'Stift',        d: 'M4 20l4-1 11-11-3-3L5 16zM13 8l3 3' },
  users:     { label: 'Gruppe',       d: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8' },
  user:      { label: 'Person',       d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8' },
  home:      { label: 'Zuhause',      d: 'M3 11l9-8 9 8M5 10v10h14V10M10 20v-6h4v6' },
  heart:     { label: 'Herz',         d: 'M12 21s-7-4.6-9.5-9A5 5 0 0 1 12 6a5 5 0 0 1 9.5 6c-2.5 4.4-9.5 9-9.5 9z' },
  star:      { label: 'Stern',        d: 'M12 3l2.8 5.8 6.4.9-4.6 4.5 1.1 6.3L12 17.5l-5.7 3 1.1-6.3L2.8 9.7l6.4-.9z' },
  chat:      { label: 'Gespräch',     d: 'M21 12a8 8 0 0 1-11.6 7.1L4 21l1.9-5.4A8 8 0 1 1 21 12z' },
  bulb:      { label: 'Idee',         d: 'M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.6 1 1.3 1 2.5h6c0-1.2.3-1.9 1-2.5A6 6 0 0 0 12 3z' },
  sun:       { label: 'Sonne',        d: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10zM12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4' },
  clock:     { label: 'Uhr',          d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2' },
  pin:       { label: 'Ort',          d: 'M12 21s7-6.5 7-11.5a7 7 0 1 0-14 0C5 14.5 12 21 12 21zM12 12a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z' },
  smile:     { label: 'Lächeln',      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM8.5 14s1.3 2 3.5 2 3.5-2 3.5-2M9 10h.01M15 10h.01' },
  trophy:    { label: 'Pokal',        d: 'M7 4h10v5a5 5 0 0 1-10 0zM7 6H4a3 3 0 0 0 3 4M17 6h3a3 3 0 0 1-3 4M12 14v4M8 21h8M9 18h6' },
  ball:      { label: 'Ball',         d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 3c2 3 2 15 0 18M3 12h18M5 7c4 2 10 2 14 0M5 17c4-2 10-2 14 0' },
  run:       { label: 'Laufen',       d: 'M14 5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM5 22l4-6 3 2 1-5-4-3 2-4 4 2 3-1M9 11l-4 1' },
  check:     { label: 'Ziel erreicht', d: 'M5 12l5 5L20 7' },
  list:      { label: 'Liste',        d: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01' },
  compass:   { label: 'Kompass',      d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM15.5 8.5l-2 5-5 2 2-5z' },
};

export const STAGE_ICON_KEYS = Object.keys(STAGE_ICONS);

/** SVG-Element eines Etappen-Icons (24er-Raster, Strich in currentColor). */
export function stageIcon(key, cls = 'sicon') {
  const def = STAGE_ICONS[key] || STAGE_ICONS.flag;
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  svg.setAttribute('class', cls);
  const path = document.createElementNS(NS, 'path');
  path.setAttribute('d', def.d);
  path.setAttribute('fill', 'none');
  path.setAttribute('stroke', 'currentColor');
  path.setAttribute('stroke-width', '2');
  path.setAttribute('stroke-linecap', 'round');
  path.setAttribute('stroke-linejoin', 'round');
  svg.append(path);
  return svg;
}
